export default async function externalComponent(url) {

    //const name = url.split('/').reverse()[0] //.match(/^(.*?)\.umd/)[1];
    
    let promise = new Promise((resolve, reject) => {

      const script = document.createElement('script');
      script.async = true;
      script.type = 'module'
      script.src = url;

      script.addEventListener('load', (e) => {
        resolve();
      });

      script.addEventListener('error', () => {
        reject(new Error(`Error loading ${url}`));
      });
      
      document.head.appendChild(script);
    });

    return await promise;
}